import { Component } from '@angular/core';
import {combineLatestWith, Subscription} from "rxjs";
import {GameService} from "../../../../services/game.service";
import {Game} from "../../../../models/game.class";

@Component({
  selector: 'app-favourites',
  templateUrl: './favourites.component.html',
  styleUrls: ['./favourites.component.scss']
})
export class FavouritesComponent {

  favouriteGames: Game[] = [];
  favouriteIds: number[] = [];
  gamesAndFavouriteIdsSubs?: Subscription;

  randomGamesForCarousel: Game[] = [];

  constructor(
    private gameService: GameService
  ) {  }

  ngOnInit(){
    this.gamesAndFavouriteIdsSubs = this.gameService.getGames().pipe(
      combineLatestWith(this.gameService.favouriteGameIds$)
    ).subscribe(([games, favouriteGameIds]) => {
      if (games && games.length && favouriteGameIds) {
        this.favouriteIds = favouriteGameIds;

        this.favouriteGames = [];
        for (const id of favouriteGameIds) {
          const game = games.getById(id)
          if(game){
            this.favouriteGames.push(game)
          }
        }

        //put disabled at the end of the list (not sorted by popularity but by 'recently-played'-order)
        if(this.favouriteGames.length){
          this.favouriteGames.sort((a,b)=>{
            if (a.isDisabled && !b.isDisabled) return 1;
            if (!a.isDisabled && b.isDisabled) return -1;
            return 0;
          })
          // console.log(this.favouriteGames)
        }


        //random games are refreshed each time favourites change
        this.randomGamesForCarousel = this.gameService.pickRandomGames(games.all, 16);
      }
    })


  }


  ngOnDestroy(){
    this.gamesAndFavouriteIdsSubs?.unsubscribe();
  }


}
